import { Injectable } from "@angular/core";
import { CrudService } from "src/app/components/shared/cruds/crud.service";
import { TiposUnidadDTO } from "src/app/models/tipo-unidad.dto";

@Injectable({ providedIn: "root" })
export class TiposUnidadService extends CrudService<TiposUnidadDTO> {
  protected controller: string = "settings/tiposunidades/";
}
